// extracted by mini-css-extract-plugin
export default {"btns":"_delete-dialog_btns__tmA4V"};